import { styled } from "@mui/material/styles";
import { Button as ButtonComponent } from "components/button";
import DropdownIconAsset from "assets/images/icons/dropdown.svg";
import { PlainButton } from "components/button/plain";

export const Container = styled("div", {
  label: "container",
})`
  position: fixed;
  background: ${({ theme }) => theme.palette.color.secondary[95]};
  border-radius: ${({ theme }) => theme.spacing(4, 4, 0, 0)};
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: flex-start;
  padding: ${({ theme }) => theme.spacing(3.5)};
  width: 100%;
  z-index: ${({ theme }) => theme.zIndex.appBar};
  flex-direction: column;
  height: ${({ theme }) => theme.spacing(21.5)};

  transition: ${({ theme }) => theme.transitions.create("height")};

  &.expanded {
    height: ${({ theme }) => theme.spacing(30)};
  }
`;

export const RowContainer = styled("div", {
  label: "row-container",
})`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const CtaButton = styled(ButtonComponent, {
  label: "cta-button",
})`
  font-size: 16px;
  width: 75%;
  align-self: center;
  bottom: ${({ theme }) => theme.spacing(2)};
  position: absolute;
`;

export const TextAndCost = styled("div", {
  label: "text-and-cost",
})`
  flex: 1;
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 16px;
  font-weight: 500;
  justify-content: center;
`;

export const AllTravelers = styled("div", { label: "all-travelers" })`
  font-size: 14px;
  font-weight: 400;
`;
export const InputContainer = styled("div", { label: "input-container" })`
  flex: 1;
  display: flex;
`;

export const Disclaimer = styled("div", {
  label: "disclaimer",
})`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.color.text.primary};
  margin-top: ${({ theme }) => theme.spacing(1.25)};
  &.error {
    color: ${({ theme }) => theme.palette.color.alert.main};
    align-self: center;
    margin-top: ${({ theme }) => theme.spacing(1)};
  }
  &.error.expanded {
    margin-top: ${({ theme }) => theme.spacing(3.5)};
  }
`;

export const ExpandButton = styled(PlainButton, {
  label: "expand-button",
})`
  margin-left: ${({ theme }) => theme.spacing(1)};
`;

export const ExpandIcon = styled(DropdownIconAsset, {
  label: "expand-icon",
})`
  fill: ${({ theme }) => theme.palette.color.primary.main};
  margin: ${({ theme }) => theme.spacing(0, 0, 0, 0.5)};
  width: ${({ theme }) => theme.spacing(1.25)};
  height: auto;
  vertical-align: middle;
  &.expanded {
    transform: rotate(0);
    transform: rotate(180deg);
  }
`;
